import { Schema } from "effect";
import { Web2AppIntegrationId, ApplicationId, Web2AppIntegrationTypeId } from "@superwall/drizzle/branded";
export class Model extends Schema.Class("superwall-api-Web2AppIntegration-Model")({
    id: Web2AppIntegrationId,
    object: Schema.Literal("web2app_integration"),
    createdAt: Schema.DateFromString,
    updatedAt: Schema.DateFromString,
    deletedAt: Schema.DateFromString.pipe(Schema.NullOr),
    name: Schema.String,
    integrationId: Web2AppIntegrationTypeId,
    enabled: Schema.Boolean,
    config: Schema.Unknown,
    applicationId: ApplicationId
}) {
}
export class Create extends Schema.Class("superwall-api-Web2AppIntegration-Create")({
    name: Schema.String,
    integrationId: Web2AppIntegrationTypeId,
    enabled: Schema.Boolean.pipe(Schema.optionalWith({
        default: ()=>true
    })),
    config: Schema.Unknown.pipe(Schema.optionalWith({
        default: ()=>({})
    }))
}) {
}
export class Update extends Schema.Class("superwall-api-Web2AppIntegration-Update")({
    name: Schema.optional(Schema.String),
    integrationId: Schema.optional(Web2AppIntegrationTypeId),
    enabled: Schema.optional(Schema.Boolean),
    config: Schema.optional(Schema.Unknown)
}) {
}
export class List extends Schema.Class("superwall-api-Web2AppIntegration-List")({
    object: Schema.Literal("list"),
    data: Schema.Array(Model)
}) {
}
